export default "__VITE_ASSET__U9kQ2GcT__"